import { render, staticRenderFns } from "./ranks.vue?vue&type=template&id=508333d4&scoped=true&"
import script from "./ranks.vue?vue&type=script&lang=js&"
export * from "./ranks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508333d4",
  null
  
)

export default component.exports